<template>
  <tr
    class="hover:bg-gray-100 transition-colors duration-150 ease-in-out text-right child:py-4 first-child:pl-16 last-child:pr-3 text-sm"
    :class="
      {
        'bg-gray-50 border-gray-100': depth <= 1,
        'bg-gray-200 border-gray-300': depth === 2,
        'bg-gray-300 border-gray-400': depth === 3,
        'bg-gray-400 border-gray-500': depth >= 4
      }
    "
  >
    <td
      class="py-3 text-left"
    >
      <div
        class="flex items-center space-x-2"
        :style="{ paddingLeft: `${(depth * 20) + 16}px` }"
      >
        <span
          class="font-semibold text-gray-900"
        >{{ $props.packageTradeItem.billItem }}</span>

        <span
          v-if="wbsCode"
          class="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded"
        >
          {{ wbsCode.code }}
        </span>

        <ProvisionalSumBadge
          v-if="tradeItem.is_provisional_sum"
        />

        <p class="w-60 text-gray-700">
          {{ tradeItem.name }}
        </p>
      </div>
    </td>

    <td class="pr-3">
      {{ australianCurrency(packageTradeItem.value) }}
    </td>

    <td
      v-if="lumpSumCost && !typingClaim"
      :class="{ 'cursor-pointer': canEditClaim }"
      class="bg-green-200/50"
      @click="typeClaim"
    >
      <div class="group flex items-center justify-end">
        <div class="group flex items-center justify-end">
          <button
            v-if="canEditClaim"
            type="button"
            class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
            @click.stop.capture="removeClaim"
          >
            <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
          </button>

          <button
            v-if="canEditClaim"
            type="button"
            class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
          >
            <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
          </button>
        </div>

        <span class="ml-2">
          {{ canEditClaim ? australianCurrency(costForm.form.current_claim) : australianCurrency(lumpSumCost.current_claim) }}
        </span>
      </div>
    </td>

    <td
      v-else-if="canEditClaim"
      class="bg-green-200/50"
    >
      <div class="">
        <AppCurrencyInput
          ref="claimInput"
          v-model.number="costForm.form.current_claim"
          name="current_claim"
          type="number"
          min="1"
          data-test="quantity-input"
          class="w-20 h-6 ml-auto form-input"
          @blur="stopTypingClaim"
          @keyup.enter="$event.target.blur()"
          @keyup.esc="resetTypingClaim"
        />
      </div>
    </td>

    <td
      v-else
      class="bg-green-200/50"
    />

    <td class="bg-green-200/50">
      {{ lumpSumCost?.current_certified ? australianCurrency(lumpSumCost.current_certified) : '' }}
    </td>

    <td
      class="bg-green-200/50"
      :class="{ 'text-red-600': hasVariance && variance !== 0 }"
      :title="hasVariance && variance !== 0 ? varianceComment?.body : ''"
    >
      {{ hasVariance ? australianCurrency(variance) : '' }}
    </td>

    <td class="bg-green-200/50">
      {{ australianCurrency(packageTradeItem.previous(claim)) }}
    </td>

    <td class="bg-green-200/50 pr-3">
      {{ australianCurrency(packageTradeItem.previous(claim) + (lumpSumCost?.current_certified || 0)) }}
    </td>

    <td
      v-if="showPercentages && !falsey(lumpSumCost?.current_claim) && !typingClaim && canEditClaim"
      :class="{ 'cursor-pointer': canEditClaim }"
      class="bg-blue-100/50"
      @click="typeClaimPercent"
    >
      <div class="group flex items-center justify-end">
        <button
          type="button"
          class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4"
            @click.stop.capture="removeClaim">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
        </button>

        <button
          v-if="canEditClaim"
          type="button"
          class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
        >
          <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
        </button>
        {{ !falsey(lumpSumCost?.current_claim) ? `${australianNumber((lumpSumCost.current_claim / packageTradeItem.value) * 100)}%` : '' }}
      </div>
    </td>

    <td
      v-else-if="showPercentages && canEditClaim"
      class="bg-blue-100/50"
    >
      <div class="">
        <AppInput
          ref="claimPercentInput"
          v-model.number="currentClaimPercent"
          name="current_claim_percent"
          type="number"
          class="w-20 h-6 ml-auto form-input"
          @blur="stopTypingClaim"
          @keyup.enter="$event.target.blur()"
          @keyup.esc="typingClaim = false"
        />
      </div>
    </td>

    <td
      v-else
      class="bg-blue-100/50"
    >
      <span v-if="showPercentages">
        {{ !falsey(lumpSumCost?.current_claim) ? `${australianNumber((lumpSumCost.current_claim / packageTradeItem.value) * 100)}%` : '' }}
      </span>
    </td>

    <td
      v-if="showPercentages"
      class="bg-blue-100/50"
    >
      {{ lumpSumCost?.current_certified ? `${australianNumber((lumpSumCost.current_certified / packageTradeItem.value) * 100)}%` : '' }}
    </td>

    <td
      v-if="showPercentages"
      class="bg-blue-100/50"
    >
      {{ australianNumber((packageTradeItem.previous(claim) / packageTradeItem.value) * 100) }}%
    </td>

    <td
      v-if="showPercentages"
      class="bg-blue-100/50 pr-3"
    >
      {{ australianNumber(((packageTradeItem.previous(claim) + (lumpSumCost?.current_certified || 0)) / packageTradeItem.value) * 100) }}%
    </td>

    <td class="pr-3">
      {{ australianCurrency(Math.abs(packageTradeItem.value - packageTradeItem.previous(claim) - (lumpSumCost?.current_certified || 0))) }}
    </td>
  </tr>
</template>

<script setup lang="ts">
import ProvisionalSumBadge from '@/components/shared/ProvisionalSumBadge.vue';
import { useFormData } from '@/composables/useFormData';
import { useSignedData } from '@/composables/useSignedData';
import { useStoreApiAction } from '@/composables/useStoreApiAction';
import { australianCurrency, australianNumber, falsey, parseUrlParams, roundDecimals } from '@/helpers';
import Claim, { ClaimStatus } from '@/models/Claim';
import PackageTradeItem from '@/models/PackageTradeItem';
import Trade from '@/models/Trade';
import TradeItem from '@/models/TradeItem';
import { useCommentsStore } from '@/store/comments';
import { useLumpSumCostsStore } from '@/store/lumpSumCosts';
import Swal from 'sweetalert2';
import { computed, nextTick, ref, watch } from 'vue';

const props = withDefaults(
  defineProps<{
    trade?: Trade;
    claim: Claim;
    tradeItem: TradeItem;
    packageTradeItem: PackageTradeItem;
    canEditClaim: boolean;
    showPercentages?: boolean;
    depth?: number;
  }>(),
  {
    depth: 0,
  },
);

const lumpSumCostsStore = useLumpSumCostsStore();

const lumpSumCost = computed(() => {
  return lumpSumCostsStore.models
    .where('trade_item_id', props.tradeItem.id)
    .where('claim_id', props.claim.id)
    .first();
});

const wbsCode = computed(() => {
  return props.packageTradeItem.wbs_code;
});

const varianceComment = computed(() => {
  return lumpSumCost.value?.comments?.[0];
});

const variance = computed(() => {
  return lumpSumCost.value?.current_claim - lumpSumCost.value?.current_certified;
});

const hasVariance = computed(() => {
  return !falsey(lumpSumCost.value?.current_claim) && !falsey(lumpSumCost.value?.current_certified);
});

const typingClaim = ref(falsey(lumpSumCost.value?.current_claim));
const signedParams = useSignedData();
const claimInput = ref();
const claimPercentInput = ref();

const typeClaim = () => {
  if(props.canEditClaim) {
    typingClaim.value = true;

    nextTick(() => {
      claimInput.value?.focusInput();
    });
  }
};

const typeClaimPercent = () => {
  if(props.canEditClaim) {
    typingClaim.value = true;

    nextTick(() => {
      claimPercentInput.value?.focusInput();
    });
  }
};

const costForm = useFormData({
  id: undefined,
  current_certified: 0,
  current_claim: 0,
  comment_trade_item: false,
  comment: undefined,
  trade_item_id: undefined,
});

const currentClaimPercent = computed({
  get() {
    return roundDecimals((costForm.form.current_claim / props.packageTradeItem.value) * 100) || undefined;
  },

  set(value) {
    costForm.form.current_claim = roundDecimals((value / 100) * props.packageTradeItem.value);
  },
});

costForm.setData({
  trade_item_id: props.tradeItem.id,
});

watch(lumpSumCost, (newValue) => {
  if(newValue) {
    if(props.canEditClaim) {
      costForm.setData({
        id: newValue.id,
        current_claim: newValue.current_claim || 0,
      });
    }
  }
}, { immediate: true });

// const storeSingleCertifiedAction = useStoreApiAction(lumpSumCostsStore.saveCertifiedCost);
const storeSingleClaimAction = useStoreApiAction(lumpSumCostsStore.saveClaimCost);
const deleteLumpSumCostAction = useStoreApiAction(lumpSumCostsStore.deleteLumpSumCost);

const formParams = computed(() => {
  return parseUrlParams(signedParams.meta.save_cost_url as string);
});

const deleteFormParams = computed(() => {
  return parseUrlParams(signedParams.meta.destroy_url as string);
});

const stopTypingClaim = () => {
  if(
    (falsey(costForm.form.current_claim) && !lumpSumCost.value) ||
    !typingClaim.value
  ) {
    return;
  }

  // if both have been cleared out, delete the cost
  if((falsey(costForm.form.current_claim) || costForm.form.current_claim === 0) && lumpSumCost.value) {
    deleteLumpSumCostAction.request(props.claim.id, deleteFormParams.value, { id: lumpSumCost.value.id }).then(() => {
      typingClaim.value = true;

      costForm.resetData(['id', 'current_claim']);
    }).catch((_error) => {
      Swal.fire({
        icon: 'error',
        title: 'Something went wrong.',
      });

      typingClaim.value = false;
    });
  } else if(costForm.form.current_claim !== 0 && costForm.form.current_claim !== lumpSumCost.value?.current_claim) {
    storeSingleClaimAction.request(props.claim.id, formParams.value, costForm.form).then((lumpSumCost) => {
      console.log(lumpSumCost);
      typingClaim.value = false;
    }).catch((error) => {
      console.log(error);

      Swal.fire({
        icon: 'error',
        title: 'Something went wrong.',
      });

      typingClaim.value = true;
    });
  } else {
    // if user didn't change the number then close typing
    typingClaim.value = costForm.form.current_claim !== lumpSumCost.value?.current_claim;
  }
};

const resetTypingClaim = () => {
  typingClaim.value = false;
  costForm.form.current_claim = lumpSumCost.value.current_claim;
};

const removeClaim = () => {
  deleteLumpSumCostAction.request(props.claim.id, deleteFormParams.value, { id: lumpSumCost.value.id }).then(() => {
    typingClaim.value = true;

    costForm.resetData(['id', 'current_claim']);
  }).catch((_error) => {
    Swal.fire({
      icon: 'error',
      title: 'Something went wrong.',
    });

    typingClaim.value = false;
  });
};
</script>

<style scoped></style>
